import { VanityPieceType } from '../../../../../__gqltypes__';
import { GET_FRAMES, GET_SKINS, GET_STICKERS } from '../../components/apolloQueries';

export const CURRENCY_TYPES = {
  CURRENCY_COIN: 'CurrencyCoin',
  CURRENCY_DIAMOND: 'CurrencyDiamond',
  CURRENCY_TOURNAMENT_TICKET: 'CurrencyTournamentTicket',
  CURRENCY_CATEGORY_FRAGMENT: 'CurrencyCategoryFragment',
  CURRENCY_VANITY_PIECE: 'CurrencyVanityPiece',
};

export const AVAILABILITY_TYPES = {
  SHOP: ['CURRENCY_DIAMOND'],
  CRAFT: ['CURRENCY_CATEGORY_FRAGMENT'],
  // unlocked with vanity pieces only, levels 2+ are upgraded with diamonds
  PIECES: ['CURRENCY_VANITY_PIECE'],
  UNAVAILABLE: ['CURRENCY_CATEGORY_FRAGMENT', 'CURRENCY_DIAMOND', 'CURRENCY_COIN'],
  EARN: [],
  EARN_EACH_LEVEL: [],
};

export const VANITY_PIECE_TYPE_LABELS: Record<VanityPieceType, string> = {
  [VanityPieceType.VINYL]: 'Vinyl',
  [VanityPieceType.FRAME]: 'Frame',
  [VanityPieceType.STICKER]: 'Sticker',
  [VanityPieceType.BADGE]: 'Badge',
};

// vanity piece type unlocking an item of the given type ('Vinyl', 'Frame' or 'Sticker')
export const getVanityPieceType = (type: string): VanityPieceType => {
  switch (type) {
    case 'Frame':
      return VanityPieceType.FRAME;
    case 'Vinyl':
      return VanityPieceType.VINYL;
    case 'Sticker':
    default:
      return VanityPieceType.STICKER;
  }
};

export const getQuery = (type: string) => {
  switch (type) {
    case 'Frame':
      return { query: GET_FRAMES, key: 'profileFrames', typeQ: 'PROFILE_FRAME' };
    case 'Vinyl':
      return { query: GET_SKINS, key: 'appskins', typeQ: 'APP_SKIN' };
    case 'Sticker':
    default:
      return { query: GET_STICKERS, key: 'stickers', typeQ: 'STICKER' };
  }
};

export const isValidAssetUrl = (asset?: string | null) => {
  if (!asset) {
    return false;
  }

  try {
    const parsed = new URL(asset);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};
